import { Vue, Component, Prop } from 'vue-property-decorator';
import { TENANT_DEFAULT } from '@/utils/constants';


@Component({
    name: 'upload-image',
    components: { },
})

export default class UploadImage extends Vue {

    @Prop({ default: {} })
    private tenant: any;

    @Prop({ default: {} })
    private tenantSettings: any;

    private uploaded: any = null;

    private isUploading: any = false;

    private defaultTenantSettings: any = TENANT_DEFAULT;


    private onUpdateFile(tenant: any) {
        this.isUploading = true;
        this.tenantSettings[this.tenant.parentKey][this.tenant.keyName] = null;
        this.uploaded = null;
        setTimeout(() => {
            if (this.isUploading && this.tenantSettings[tenant.parentKey][tenant.keyName] instanceof File) {
                this.uploaded = URL.createObjectURL(this.tenantSettings[tenant.parentKey][tenant.keyName]);
                setTimeout(() => {
                    this.isUploading = false;
                }, 20);
            }
        }, 20);
    }

    private removeImage() {
        this.tenantSettings[this.tenant.parentKey][this.tenant.keyName] = null;
        this.uploaded = null;
        this.$bvModal.hide('imagePreview');
    }
}
